import { localStorageService } from '../../services/StorageService';
import LOCALSTORAGE from '../constants/localStorage';
import segmentConfig from '../constants/segmentConfig';

/**
 * Retrieves the current view type of vehicle cards based on the local storage key
 *
 * @return {string | undefined} The current view type ('List View', 'Power View', 'Side Rail View') or undefined if none is found.
 */
const getVehicleCardsViewType = (): string | undefined => {
  const viewType = localStorageService.getItem(
    LOCALSTORAGE.STORAGE_SELECTED_VIEW
  );

  if (viewType) {
    return segmentConfig.vehicleCardViewType[viewType];
  }

  return undefined;
};

export default getVehicleCardsViewType;
